import { defineFieldFormInterface } from "~/entities/field";
import InputHashInterface from "./InputHashInterface.vue";

export default defineFieldFormInterface({
  interface: "input-hash",
  component: InputHashInterface,
});
